import SectionHeading from "@/pages/home/components/SectionHeading";
import { vipComparison, vipTiers } from "@/mocks/content";

export default function VipCompare() {
  const toneClass = (tone: string) => {
    if (tone === "primary") return "bg-primary-500 text-background-50";
    if (tone === "secondary") return "bg-secondary-500 text-background-50";
    return "bg-background-200 text-foreground-700";
  };

  const cellTone = (value: string) => {
    if (value === "不支持" || value === "不开放" || value === "无")
      return "text-foreground-400";
    if (value === "受限" || value === "部分支持" || value === "固定低清")
      return "text-foreground-600";
    return "text-foreground-900 font-medium";
  };

  return (
    <section id="vip" className="w-full bg-foreground-950 py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="VIP 权限说明"
          title="三档权限，差别到底在哪"
          desc="快猫的权限分为游客、注册用户与 VIP 三档。基础浏览人人可用，差别主要体现在清晰度、回放、深夜档范围和专属标识上。"
          light
        />

        <div className="mt-10 md:mt-14 rounded-lg overflow-hidden border border-white/10 bg-background-50">
          <div className="overflow-x-auto km-scrollbar">
            <table className="w-full min-w-[680px] border-collapse text-left">
              <thead>
                <tr className="bg-background-100">
                  <th className="px-4 md:px-6 py-4 text-sm font-medium text-foreground-500 w-[34%]">功能范围</th>
                  {vipTiers.map((t) => (
                    <th key={t.label} className="px-4 md:px-6 py-4 w-[22%]">
                      <span className={`inline-flex flex-col px-3.5 py-2 rounded-lg ${toneClass(t.tone)}`}>
                        <span className="font-heading font-bold text-sm whitespace-nowrap">{t.label}</span>
                        <span className="text-[10px] opacity-80 whitespace-nowrap">{t.sub}</span>
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {vipComparison.map((row, i) => (
                  <tr
                    key={row.feature}
                    className={`border-t border-background-200 ${row.highlight ? "bg-accent-50/60" : i % 2 === 1 ? "bg-background-50" : "bg-background-100/50"}`}
                  >
                    <td className="px-4 md:px-6 py-4 text-sm text-foreground-800">
                      <span className="flex items-center gap-2">
                        {row.highlight && <i className="ri-star-fill text-accent-500 text-xs"></i>}
                        {row.feature}
                      </span>
                    </td>
                    <td className={`px-4 md:px-6 py-4 text-sm ${cellTone(row.guest)}`}>{row.guest}</td>
                    <td className={`px-4 md:px-6 py-4 text-sm ${cellTone(row.member)}`}>{row.member}</td>
                    <td className="px-4 md:px-6 py-4 text-sm">
                      <span className="inline-flex items-center gap-1.5 text-primary-700 font-medium">
                        {row.vip}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="rounded-lg bg-white/5 border border-white/10 p-5">
            <i className="ri-hd-line text-2xl text-accent-400"></i>
            <h3 className="mt-3 font-heading font-bold text-background-50">清晰度是核心差异</h3>
            <p className="mt-2 text-sm text-background-200 leading-relaxed">权限越高，可手动切换的画质档位越高，深夜档的观感差别尤其明显。</p>
          </div>
          <div className="rounded-lg bg-white/5 border border-white/10 p-5">
            <i className="ri-moon-clear-line text-2xl text-accent-400"></i>
            <h3 className="mt-3 font-heading font-bold text-background-50">深夜档范围不同</h3>
            <p className="mt-2 text-sm text-background-200 leading-relaxed">同一时段下，不同权限能看到的内容范围不同，VIP 的范围最完整。</p>
          </div>
          <div className="rounded-lg bg-white/5 border border-white/10 p-5">
            <i className="ri-history-line text-2xl text-accent-400"></i>
            <h3 className="mt-3 font-heading font-bold text-background-50">回放与记录</h3>
            <p className="mt-2 text-sm text-background-200 leading-relaxed">注册用户可看部分回放，VIP 支持完整回放并保留观看进度记录。</p>
          </div>
        </div>
      </div>
    </section>
  );
}